import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const PricingPageRedirectButtonBase = ({
  children,
  uiButtonProps
}) => {
  return /*#__PURE__*/_jsx(Button, Object.assign({
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.pricingPageRedirect"
    })
  }));
};
export const PricingPageRedirectButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.PRICING_PAGE_REDIRECT_BUTTON,
  children: /*#__PURE__*/_jsx(PricingPageRedirectButtonBase, Object.assign({}, props))
});